import { render, staticRenderFns } from "./MenuNi.vue?vue&type=template&id=4b53a9fc&scoped=true&"
import script from "./MenuNi.vue?vue&type=script&lang=js&"
export * from "./MenuNi.vue?vue&type=script&lang=js&"
import style0 from "./MenuNi.vue?vue&type=style&index=0&id=4b53a9fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b53a9fc",
  null
  
)

export default component.exports